<template>
  <div class="item-container item-body-container" :class="[prettyFormatOfEventType(data.type)]">
    <div class="item item-date">
      <span class="date-time">{{formatLongDateTimeWithMs(data.client_timestamp)}}</span>
      <span class="time">{{formatLongTimeWithMs(data.client_timestamp)}}</span>
      <span class="date">
        <small>{{formatLongDateOnly(data.client_timestamp)}}</small>
      </span>
    </div>
    <div class="item item-primary" :class="[prettyFormatOfEventType(data.type)]">
      <div>{{prettyFormatOfEventType(data.type)}}</div>
      <small
        class="error"
        v-if="data.type === 'playback.error'"
      >{{data.error_message}} error code : {{data.error_code}}</small>
      <div class="item item-mobile">
        <div class="">
          <span class="label">Playback Resolution : </span>
          {{data.playback_resolution || '-'}}
          <span
            class="badge badge-light"
            v-if="isResolutionManual(data)"
          >{{data.playback_resolution_mode}}</span>
        </div>
        <div
          class=""
        >
        <span class="label">Bandwidth Estimate : </span>
        {{ data.bandwidth_estimate ? transformBitToMbit(data.bandwidth_estimate) : '-'}}
        </div>
        <div class="">
          <span class="label">Buffer Health : </span>
          <span v-if="data.buffer_health">{{data.buffer_health.toFixed(2)}}</span>
          <span v-if="!data.buffer_health">-</span>
        </div>
        <div class="">
          <span class="label">Response Time : </span>
          <span v-if="data.response_time">{{transformMillisecToSec(data.response_time)}}</span>
          <span v-if="!data.response_time">-</span>
        </div>
        <div class="">
          <span class="label">Note : </span>
          <ol v-if="!getEventIssue(data)">
            <li v-for="(issue, indexIssue) in getEventIssue(data)" :key="indexIssue">{{issue}}</li>
          </ol>
        </div>
      </div>
    </div>
    <div class="item item-playhead">
      <span>{{ data.playhead_position ? transformTimeCode(data.playhead_position) : '-'}}</span>
    </div>
    <div class="item item-res">
      {{data.playback_resolution || '-'}}
      <span
        class="badge badge-light"
        v-if="isResolutionManual(data)"
      >{{data.playback_resolution_mode}}</span>
    </div>
    <div
      class="item item-bandwidth"
    >{{ data.bandwidth_estimate ? transformBitToMbit(data.bandwidth_estimate) : '-'}}</div>
    <div class="item item-buffer-health">
      <span v-if="data.buffer_health">{{data.buffer_health.toFixed(2)}}</span>
      <span v-if="!data.buffer_health">-</span>
    </div>
    <div class="item item-response-time">
      <span v-if="data.response_time">{{transformMillisecToSec(data.response_time)}}</span>
      <span v-if="!data.response_time">-</span>
    </div>
    <div class="item item-issue">
      <ol>
        <li v-for="(issue, indexIssue) in getEventIssue(data)" :key="indexIssue">{{issue}}</li>
      </ol>
    </div>
  </div>
</template>

<script>
/* eslint camelcase: "off" */
import _ from 'lodash';
import { mapGetters } from 'vuex';
import dateFormatter from '@/utils/dateFormatter';
import unitFormatter from '@/utils/unitFormatter';

export default {
  mixins: [dateFormatter, unitFormatter],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    indexItem: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(['eventIds', 'getEventById']),
  },
  methods: {
    isResolutionManual(event) {
      return event.playback_resolution_mode === 'manual';
    },
    getEventIssue(event) {
      const issues = [];

      if (this.isResolutionMatchWithBandwidth(event)) {
        issues.push('Resolution ไม่เหมาะสมกับ Bandwidth Estimate');
      }

      const previousEvent = this.getEventById([this.indexItem - 1]);
      if (previousEvent && previousEvent.cdn_server !== event.cdn_server) {
        issues.push(
          `มีการสลับโหนด CDN จาก ${previousEvent.cdn_server} มายัง ${event.cdn_server}`,
        );
      }

      return issues;
    },
    isResolutionMatchWithBandwidth(event) {
      const { playback_resolution, bandwidth_estimate } = event;

      if (!playback_resolution) {
        return false;
      }

      const rules = [
        { bandwidth: 128000, resolution: '144p' },
        { bandwidth: 288000, resolution: '240p' },
        { bandwidth: 640000, resolution: '360p' },
        { bandwidth: 1440000, resolution: '480p' },
        { bandwidth: 3200000, resolution: '720p' },
      ];

      const findBandwidthEstimate = _.find(
        rules,
        rule => rule.resolution === playback_resolution,
      );

      if (findBandwidthEstimate) {
        return (
          findBandwidthEstimate.bandwidth >= this.transformMbitToBit(bandwidth_estimate)
        );
      }
      return false;
    },
    getEventType() {
      const uniqEvent = _.uniqBy(this.events, 'type');
      return _.map(uniqEvent, item => item.type);
    },
    prettyFormatOfEventType(type) {
      const regex = /playback./gi;
      return type.replace(regex, '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/event-list.scss';
</style>
